(function () {
  function setImp(el, props) {
    for (var k in props) el.style.setProperty(k, props[k], 'important');
  }

  function fit(el) {
    el.style.marginLeft = '0px';
    el.style.marginRight = '0px';
    el.style.width = 'auto';
    var rect = el.getBoundingClientRect();
    el.style.width = window.innerWidth + 'px';
    el.style.marginLeft = '-' + rect.left + 'px';

    var footer = el.querySelector('.lock__notificationFooter');
    if (footer) {
      setImp(footer, {
        'box-shadow': 'none',
        'filter': 'none',
        'display': 'flex',
        'flex-direction': 'row',
        'flex-wrap': 'nowrap',
        'align-items': 'center',
        'justify-content': 'center',
        'gap': '0px',
        'margin': '32px auto 0',
        'padding': '0',
        'width': '100%',
        'max-width': '300px',
        'background': 'transparent'
      });
    }

    var input = el.querySelector('#passcode');
    if (input) {
      setImp(input, {
        'height': '52px',
        'line-height': '52px',
        'min-height': '52px',
        'max-height': '52px',
        'margin': '0',
        'padding': '0 4px',
        'border': '0',
        'border-bottom': '1px solid rgba(255,255,255,0.6)',
        'border-radius': '0',
        'box-shadow': 'none',
        'outline': 'none',
        'box-sizing': 'border-box',
        'vertical-align': 'middle',
        'flex': '1 1 auto',
        'min-width': '0',
        'width': 'auto',
        'background': 'transparent',
        'background-color': 'transparent',
        'color': '#fff'
      });
    }

    var btn = el.querySelector('#passcodebtn');
    if (btn) {
      setImp(btn, {
        'height': '52px',
        'line-height': '52px',
        'min-height': '52px',
        'max-height': '52px',
        'margin': '0',
        'padding': '0 14px',
        'border': '0',
        'border-radius': '0',
        'box-shadow': 'none',
        'outline': 'none',
        'box-sizing': 'border-box',
        'vertical-align': 'middle',
        'flex': '0 0 auto',
        'background': 'transparent',
        'background-color': 'transparent',
        'color': '#fff',
        'font-size': '12px',
        'font-weight': '600',
        'text-transform': 'uppercase',
        'letter-spacing': '0.06em',
        'white-space': 'nowrap'
      });
      var span = btn.querySelector('span');
      if (span) {
        setImp(span, {
          'color': '#fff',
          'line-height': '52px',
          'font-size': '12px',
          'font-weight': '600',
          'text-transform': 'uppercase',
          'letter-spacing': '0.06em',
          'white-space': 'nowrap',
          'display': 'inline-flex',
          'align-items': 'center',
          'gap': '8px'
        });
        if (span.getAttribute('data-vault-arrow') !== '1') {
          span.textContent = span.textContent.trim() + '  →';
          span.setAttribute('data-vault-arrow', '1');
        }
      }
    }
  }

  function run() {
    var el = document.querySelector('.lock__notificationTemplateWrapper');
    if (el) {
      document.body.classList.add(
        'has-header-transparent',
        'has-first-section-overlay-header',
        'vault-gate-open'
      );
      var video = el.querySelector('.vault-gate__video');
      if (video) video.remove();
      fit(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('resize', run);

  var mo = new MutationObserver(run);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
